import React, { memo, forwardRef } from 'react';
const InnerClassFormatter = (_ref, ref) => {
  let {
    value,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: className
  }, value);
};
export default /*#__PURE__*/memo(/*#__PURE__*/forwardRef(InnerClassFormatter));